<template>
  <div class="container">
    <!-- 左侧tab -->
    <div class="left">
      <div class="item" :class="typeIndex == 0 ? 'active' : ''" @click="onChangeType(0)"><svg-icon class-name="svgs" icon-class="common" /><span> {{ $t('tabBar').asset }}{{ $t('asset').Overview }}</span>
      </div>
      <div class="item" :class="typeIndex == 1 ? 'active' : ''" @click="onChangeType(1)"><svg-icon class-name="svgs" icon-class="position" /><span>{{ $t('asset').contract }}</span>
      </div>
      <div class="item" :class="typeIndex == 2 ? 'active' : ''" @click="onChangeType(2)"><svg-icon class-name="svgs" icon-class="market" /><span>{{ $t('public').spot }}</span>
      </div>
      <div class="item" :class="typeIndex == 3 ? 'active' : ''" @click="onChangeType(3)"><svg-icon class-name="svgs" icon-class="asset" /><span>{{ $t('asset').wallet }}</span>
      </div>
      <div class="item" :class="typeIndex == 4 ? 'active' : ''" @click="onChangeType(4)"><svg-icon class-name="svgs" icon-class="heel" /><span>{{ $t('tabBar').heel }}</span>
      </div>
    </div>
    <div class="info">
      <!-- 总览 -->
      <div class="totalInfo" v-if="typeIndex == 0">
        <!-- 总资产估值 -->
        <div class="title">
          <div class="lef"> <span> {{ $t('tabBar').asset }}{{ $t('asset').Overview }}</span> <van-icon name="eye-o" color="var(--text_color)" size="25" v-if="isShow" @click="isShow = false" />
            <van-icon name="closed-eye" color="var(--text_color)" size="25" v-else @click="isShow = true" />
          </div>
          <!-- 充值 -->
          <div class="btn" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">{{ $t('asset').Recharge }}</div>
        </div>
        <div class="topInfo">
          <div class="tit">
            <span>{{ $t('asset').Totalassetvaluation }}（USDT）</span>
          </div>
          <div class="num" v-if="isShow">{{ propertyVo.totalAmount }}<span>≈USD${{ propertyVo.totalAmount }}</span>
          </div>
          <div class="num" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}<span>{{
            propertyVo.totalAmount.toString().replace(/./g, '*') }}</span></div>
          <div class="billss" @click="$router.push({ name: 'Bill' })">{{ $t('bill').title }}</div>
        </div>
        <!-- 合约账户 -->
        <div class="item" @click="onChangeType(1)">
          <div class="left"><svg-icon class-name="svgs" icon-class="position" />{{ $t('asset').Contractaccount }}</div>
          <div class="right">
            <div class="rr">
              <div class="r1">{{ propertyVo.totalAMount_contract }} USDT
              </div>
              <div class="r2">≈USD${{ propertyVo.totalAMount_contract }}</div>
            </div>
            <van-icon name="arrow" color="var(--ntext_color)" size="13" />
          </div>
        </div>
        <!-- 现货账户 -->
        <div class="item" @click="onChangeType(2)">
          <div class="left"><svg-icon class-name="svgs" icon-class="market" />{{ $t('asset').Spotaccount }}</div>
          <div class="right">
            <div class="rr">
              <div class="r1">{{ propertyVo.totalAMount_coin }} USDT
              </div>
              <div class="r2">≈USD${{ propertyVo.totalAMount_coin }}</div>
            </div>
            <van-icon name="arrow" color="var(--ntext_color)" size="13" />
          </div>
        </div>
        <!-- 钱包账户 -->
        <div class="item" @click="onChangeType(3)">
          <div class="left"><svg-icon class-name="svgs" icon-class="asset" />{{ $t('asset').Walletaccount }}</div>
          <div class="right">
            <div class="rr">
              <div class="r1">{{ propertyVo.totalAMount_wallet }} USDT
              </div>
              <div class="r2">≈USD${{ propertyVo.totalAMount_wallet }}</div>
            </div>
            <van-icon name="arrow" color="var(--ntext_color)" size="13" />
          </div>
        </div>
        <!-- 理财账户 -->
        <div class="item" @click="onChangeType(4)">
          <div class="left"><svg-icon class-name="svgs" icon-class="heel" />{{ $t('finance').financeAccount }}</div>
          <div class="right">
            <div class="rr">
              <div class="r1">{{ propertyVo.totalAMount_finance }} USDT
              </div>
              <div class="r2">≈USD${{ propertyVo.totalAMount_finance }}</div>
            </div>
            <van-icon name="arrow" color="var(--ntext_color)" size="13" />
          </div>
        </div>
      </div>
      <!-- 合约 -->
      <div class="contractInfo" v-if="typeIndex == 1">
        <div class="title">
          <div class="lef"> <span> {{ $t('asset').contract }}</span> <van-icon name="eye-o" color="var(--text_color)" size="25" v-if="isShow" @click="isShow = false" />
            <van-icon name="closed-eye" color="var(--text_color)" size="25" v-else @click="isShow = true" />
          </div>
          <div class="btns">
            <!-- 充值 -->
            <div class="t1" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">{{ $t('asset').Recharge }}</div>
            <!-- 划转 -->
            <div class="t2" @click="$router.push({ name: 'AssetTransfer', query: { t: 1 } })">{{ $t('asset').Transfer }}</div>
          </div>
        </div>
        <div class="topInfo">
          <div class="numInfo">
            <div class="items">
              <div class="tit">
                <span>{{ $t('asset').ValuationContractAssets }}（USDT）</span>
              </div>
              <div class="num" v-if="isShow">{{ propertyVo.totalAmount }}<span>≈USD${{ propertyVo.totalAmount }}</span>
              </div>
              <div class="num" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}<span>*****{{
                propertyVo.totalAmount.toString().replace(/./g, '*') }}</span></div>
            </div>
            <div class="items">
              <div class="tit">
                <span>{{ $t('asset').profitloss }}（USDT）</span>
              </div>
              <div class="num" v-if="isShow">{{ propertyVo.profitTotalAmount }}<span>≈USD${{
                propertyVo.profitTotalAmount }}</span>
              </div>
              <div class="num" v-else>{{ propertyVo.profitTotalAmount.toString().replace(/./g, '*') }}<span>*****{{
                propertyVo.profitTotalAmount.toString().replace(/./g, '*') }} </span></div>
            </div>
          </div>
          <div class="billss" @click="$router.push({ name: 'Bill' })">{{ $t('bill').title }}</div>
        </div>
        <!-- <div class="contTabs">
          <span :class="contractIndex == 0 ? 'active' : ''" @click="contractIndex = 0">{{ $t('public').USDTcontract
          }}</span>
          <span :class="contractIndex == 1 ? 'active' : ''" @click="contractIndex = 1">{{
            $t('public').Fiatcurrencycontract
          }}</span>
        </div> -->
        <!-- 标题 -->
        <div class="tits">
          <span>{{ $t('asset').Currency }}</span><span>{{ $t('asset').balance }}</span><span>{{ $t('asset').profitloss
          }}</span>
          <span>{{ $t('asset').occupy }}</span><span>{{ $t('asset').available }}</span><span> </span>
        </div>
        <!-- USDT合约 -->
        <div class="item" v-if="contractIndex == 0">
          <div class="leftss"> <img class="img" src="@/assets/img/USDT.png" /><span>USDT</span></div>
          <div class="right">
            <div class="rr">
              <div class="r1">{{ propertyVo.totalAMount_usdt }}
              </div>
              <div class="r2">≈USD${{ propertyVo.totalAMount_usdt }}</div>
            </div>
          </div>
          <span>{{ propertyVo.profitAmount_usdt }}</span><span>{{ propertyVo.useAmount_usdt
          }}</span><span>{{ propertyVo.amount_usdt }}</span>
          <div class="itm3" @click="$router.push({ name: 'Position' })">{{ $t('asset').Viewallpositions
          }}</div>
        </div>
        <!-- 法币合约 -->
        <div class="item" v-if="contractIndex == 1">
          <div class="leftss">
            <div class="img2">$</div><span>USD</span>
          </div>
          <div class="right">
            <div class="rr">
              <div class="r1">{{ propertyVo.totalAMount_legal }}
              </div>
              <div class="r2">≈USD${{ propertyVo.totalAMount_legal }}</div>
            </div>
          </div>
          ><span>{{ propertyVo.profitAmount_legal }}</span><span>{{ propertyVo.useAmount_legal
          }}</span><span>{{ propertyVo.amount_legal }}</span>
          <div class="itm3" @click="$router.push({ name: 'Position' })">{{ $t('asset').Viewallpositions
          }}</div>
        </div>
      </div>
      <!-- 现货 -->
      <div class="coinInfo" v-if="typeIndex == 2">
        <div class="title">
          <div class="lef"> <span> {{ $t('public').spot }}</span> <van-icon name="eye-o" color="var(--text_color)" size="25" v-if="isShow" @click="isShow = false" />
            <van-icon name="closed-eye" color="var(--text_color)" size="25" v-else @click="isShow = true" />
          </div>
          <div class="btns">
            <!-- 充值 -->
            <div class="t1" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">{{ $t('asset').Recharge }}</div>
            <!-- 闪兑 -->
            <div class="t2" @click="$router.push({ name: 'AssetFlashcash', query: { t: 3 } })">{{ $t('asset').flashcash
              }}
            </div>
            <!-- 划转 -->
            <div class="t2" @click="$router.push({ name: 'AssetTransfer', query: { t: 3 } })">{{ $t('asset').Transfer }}</div>
          </div>
        </div>
        <!-- 现货资产估值 -->
        <div class="topInfo">
          <div class="tit">
            <span>{{ $t('asset').Valuationspotassets }}（USDT）</span>
          </div>
          <div class="num" v-if="isShow">{{ propertyVo.totalAmount }}<span>≈USD${{ propertyVo.totalAmount }}</span>
          </div>
          <div class="num" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}<span>*****{{
            propertyVo.totalAmount.toString().replace(/./g, '*') }}</span></div>
          <div class="billss" @click="$router.push({ name: 'Bill' })">{{ $t('bill').title }}</div>
        </div>
        <!-- 隐藏零余额资产 -->
        <div class="lable" @click="isHideZero = !isHideZero"><van-checkbox icon-size="12" v-model="isHideZero" checked-color="var(--text_color)" shape="square"></van-checkbox><span> {{
              $t('asset').Hidezerobalanceassets
            }}</span></div>
        <!-- 标题 -->
        <div class="tits">
          <span>{{ $t('asset').Currency }}</span><span>{{ $t('asset').balance }}</span><span>{{
            $t('asset').occupy }}</span><span>{{ $t('asset').available }}</span>
        </div>
        <!-- 币种 -->
        <div v-for="(dItem, dIndex) in propertyVo.propertyList" :key="`coin${dIndex}`">
          <div class="item" v-if="!isHideZero || dItem.totalAmount > 0" @click="toFlashcash(3, dItem.currency)">
            <div class="leftss">
              <img class="img" src="@/assets/img/USDT.png" v-if="dItem.currency == 'USDT'" />
              <img class="img" :src="baseUrl + dItem.logoUrl" v-else />
              <span>{{ dItem.currency }}</span>
            </div>
            <div class="right">
              <div class="rr">
                <div class="r1">{{ dItem.totalAmount }}
                </div>
                <div class="r2">≈USD${{ dItem.usdtAmount }}</div>
              </div>
            </div>
            <span>{{ dItem.useAmount }}</span><span>{{ dItem.amount }}</span>
          </div>
        </div>
      </div>
      <!-- 钱包 -->
      <div class="walletInfo" v-if="typeIndex == 3">
        <div class="title">
          <div class="lef"> <span> {{ $t('asset').wallet }}</span> <van-icon name="eye-o" color="var(--text_color)" size="25" v-if="isShow" @click="isShow = false" />
            <van-icon name="closed-eye" color="var(--text_color)" size="25" v-else @click="isShow = true" />
          </div>
          <div class="btns">
            <!-- 充值 -->
            <div class="t1" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">{{ $t('asset').Recharge }}</div>
            <!-- 闪兑 -->
            <div class="t2" @click="$router.push({ name: 'AssetFlashcash', query: { t: 4 } })">{{ $t('asset').flashcash
            }}
            </div>
            <!-- 划转 -->
            <div class="t2" @click="$router.push({ name: 'AssetTransfer', query: { f: 3, t: 4 } })">{{ $t('asset').Transfer }}</div>
            <!-- 提现 -->
            <div class="t2" @click="$router.push({ name: 'WithCurrency' })" v-if="!$store.state.isSim">{{ $t('asset').Withdrawal }}</div>
          </div>
        </div>
        <!-- 钱包资产估值 -->
        <div class="topInfo">
          <div class="tit">
            <span>{{ $t('asset').ValuationWalletAssets }}</span>
          </div>
          <div class="num" v-if="isShow">{{ propertyVo.totalAmount }}<span>≈USD${{ propertyVo.totalAmount }}</span>
          </div>
          <div class="num" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}<span>*****{{
            propertyVo.totalAmount.toString().replace(/./g, '*') }}</span></div>
          <div class="billss" @click="$router.push({ name: 'Bill' })">{{ $t('bill').title }}</div>
        </div>
        <!-- 隐藏零余额资产 -->
        <div class="lable" @click="isHideZero = !isHideZero"><van-checkbox icon-size="12" v-model="isHideZero" checked-color="var(--text_color)" shape="square"></van-checkbox><span> {{
              $t('asset').Hidezerobalanceassets
            }}</span></div>
        <!-- 标题 -->
        <div class="tits">
          <span>{{ $t('asset').Currency }}</span><span>{{ $t('asset').balance }}</span><span>{{
            $t('asset').occupy }}</span><span>{{ $t('asset').available }}</span>
        </div>
        <div v-for="(dItem, dIndex) in propertyVo.propertyList" :key="`wallet${dIndex}`">
          <div class="item" v-if="!isHideZero || dItem.totalAmount > 0" @click="toFlashcash(4, dItem.currency)">
            <div class="leftss">
              <img class="img" :src="require(`@/assets/img/${dItem.currency}.png`)" />
              <span>{{ dItem.currency }}</span>
            </div>
            <div class="right">
              <div class="rr">
                <div class="r1">{{ dItem.totalAmount }}
                </div>
                <div class="r2">≈USD${{ dItem.usdtAmount }}</div>
              </div>
            </div>
            <span>{{ dItem.useAmount }}</span><span>{{ dItem.amount }}</span>
          </div>
        </div>
      </div>
      <!-- 理财 -->
      <div class="financeInfo" v-if="typeIndex == 4">
        <div class="title">
          <div class="lef"> <span>{{ $t('tabBar').heel }}</span> <van-icon name="eye-o" color="var(--text_color)" size="25" v-if="isShow" @click="isShow = false" />
            <van-icon name="closed-eye" color="var(--text_color)" size="25" v-else @click="isShow = true" />
          </div>
          <div class="btns">
            <!-- 充值 -->
            <div class="t1" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">{{ $t('asset').Recharge }}</div>
            <!-- 划转 -->
            <div class="t2" @click="$router.push({ name: 'AssetTransfer', query: { t: 5 } })">{{ $t('asset').Transfer }}</div>
          </div>
        </div>
        <div class="topInfo">
          <div class="numInfo">
            <div class="items">
              <div class="tit">
                <span>{{ $t('finance').financeAssetAmount }}（USDT）</span>
              </div>
              <div class="num" v-if="isShow">{{ propertyVo.totalAmount }}<span>≈USD${{ propertyVo.totalAmount }}</span>
              </div>
              <div class="num" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}<span>*****{{
                propertyVo.totalAmount.toString().replace(/./g, '*') }}</span></div>
            </div>
          </div>
          <div class="billss" @click="$router.push({ name: 'Bill' })">{{ $t('bill').title }}</div>
        </div>
        <!-- 标题 -->
        <div class="tits">
          <span>{{ $t('asset').Currency }}</span><span>{{ $t('asset').balance }}</span>
          <span>{{ $t('asset').occupy }}</span><span>{{ $t('asset').available }}</span><span> </span>
        </div>
        <!-- USDT合约 -->
        <div class="item">
          <div class="leftss"> <img class="img" src="@/assets/img/USDT.png" /><span>USDT</span></div>
          <div class="right">
            <div class="rr">
              <div class="r1">{{ propertyVo.totalAmount }}
              </div>
              <div class="r2">≈USD${{ propertyVo.usdtAmount }}</div>
            </div>
          </div>
          <span>{{ propertyVo.useAmount
          }}</span><span>{{ propertyVo.amount }}</span>
          <div class="itm3" @click="$router.push({ name: 'FinanceList' })">{{ $t('asset').Viewallpositions
          }}</div>
        </div>
      </div>
      <!-- 充值选择 -->
      <van-popup v-model="showRechargeSelect" position="center" style="width: 400px;" closeable>
        <div class="rechargeSelInfo">
          <div class="tit">{{ $t('asset').Recharge }}</div>
          <div class="tabs" @click="$goRecharge('RechargeCurrency')">{{ $t('asset').Cryptocurrencyrecharge
          }}
            <span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span>
          </div>
          <div class="tabs" @click="$goRecharge('Recharge')">{{ $t('asset').Fiatcurrencyrecharge
          }}<span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span></div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import onShowMixin from '@/mixins/onShow.js';

export default {
  mixins: [onShowMixin],
  components: {
  },
  data() {
    return {
      baseUrl: window.baseURL,
      isHideZero: false,
      showRechargeSelect: false,
      isShow: true,
      typeIndex: 0,
      contractIndex: 0,
      propertyVo: {}
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getPropertyInfo()
  },
  methods: {
    onShow() {
      this.getPropertyInfo()
    },
    onChangeType(val) {
      this.typeIndex = val
      this.getPropertyInfo()
    },
    //跳转闪兑
    toFlashcash(t, b) {
      if (b == 'USDT')
        this.$router.push({ name: 'AssetFlashcash', query: { t, b: null } })
      else
        this.$router.push({ name: 'AssetFlashcash', query: { t, b } })
    },
    //获取资产统计
    async getPropertyInfo() {
      this.propertyVo = {}
      const res = await userApi.getPropertyInfo({ type: this.typeIndex })
      this.propertyVo = res.data
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);
  display: flex;

  .left {
    width: 20%;
    margin: 0 50px 0 30px;

    .item {
      display: flex;
      align-items: center;
      padding: 15px 30px;
      color: var(--ntext_color);

      &:hover {
        opacity: 0.8;
      }

      .svgs {
        width: 20px;
        height: 20px;
        color: var(--text_color);
      }

      span {
        margin-left: 30px;
        font-size: 15px;
        font-weight: bold;
      }
    }

    .active {
      background: var(--info_color);
      border-radius: 30px;
      color: var(--text_color);
    }
  }

  .info {
    width: 80%;
    margin-right: 30px;

    .totalInfo {
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .lef {
          font-size: 25px;
          font-weight: bold;
          color: var(--text_color);
          display: flex;
          align-items: center;

          span {
            margin-right: 10px;
          }
        }

        .btn {
          padding: 15px 30px;
          font-size: 14px;
          color: var(--background_color);
          background: var(--text_color);
          border-radius: 25px;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .topInfo {
        margin: 30px 0 50px 0;
        padding: 30px;
        border-radius: 15px;
        background: var(--info_color);

        .tit {
          display: flex;
          align-items: center;

          span {
            margin-left: 5px;
            font-size: 14px;
            color: var(--ntext_color);
          }
        }

        .num {
          margin-top: 20px;
          font-size: 30px;
          font-weight: 800;
          color: var(--text_color);

          span {
            margin-left: 5px;
            font-size: 16px;
            font-weight: normal;
            color: var(--ntext_color);
          }
        }

        .billss {
          margin-top: 20px;
          font-size: 14px;
          color: #3966ec;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .item {
        padding: 30px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid var(--info_color);
        border-bottom: 1px solid var(--info_color);

        &:hover {
          background: var(--info_color);
        }

        .left {
          font-size: 18px;
          color: var(--text_color);
          font-weight: bold;

          .svgs {
            width: 21px;
            height: 21px;
            color: var(--text_color);
            margin-right: 30px;
          }
        }

        .right {
          display: flex;
          align-items: center;

          .rr {
            margin-right: 5px;
            text-align: right;

            .r1 {
              font-size: 18px;
              color: var(--text_color);
              font-weight: bold;
            }

            .r2 {
              margin-top: 10px;
              font-size: 15px;
              color: var(--ntext_color);
            }
          }
        }
      }
    }

    .contractInfo {
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .lef {
          font-size: 25px;
          font-weight: bold;
          color: var(--text_color);
          display: flex;
          align-items: center;

          span {
            margin-right: 10px;
          }
        }

        .btns {
          display: flex;
          align-items: center;
          justify-content: center;

          .t1 {
            padding: 15px 30px;
            font-size: 14px;
            color: var(--background_color);
            background: var(--text_color);
            border-radius: 25px;

            &:hover {
              opacity: 0.8;
            }
          }

          .t2 {
            margin-left: 20px;
            padding: 15px 30px;
            font-size: 14px;
            color: var(--text_color);
            background: var(--info_color);
            border-radius: 25px;

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }

      .topInfo {
        margin-top: 30px;
        padding: 30px;
        border-radius: 15px;
        background: var(--info_color);

        .numInfo {
          display: flex;

          .items {
            margin-right: 200px;

            .tit {
              display: flex;
              align-items: center;

              span {
                margin-left: 5px;
                font-size: 14px;
                color: var(--ntext_color);
              }
            }

            .num {
              margin-top: 20px;
              font-size: 30px;
              font-weight: 800;
              color: var(--text_color);

              span {
                margin-left: 5px;
                font-size: 16px;
                font-weight: normal;
                color: var(--ntext_color);
              }
            }
          }
        }

        .billss {
          margin-top: 20px;
          font-size: 14px;
          color: #3966ec;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .contTabs {
        margin-top: 50px;
        margin-left: 20px;
        font-size: 16px;
        font-weight: bold;
        color: var(--ntext_color);

        span {
          margin-right: 50px;
        }

        .active {
          color: var(--text_color);
        }
      }

      .tits {
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px;
        background: var(--info_color);
        font-size: 12px;
        color: var(--ntext_color);
        opacity: 0.8;

        span {
          width: 16%;
        }
      }

      .item {
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid var(--info_color);

        &:hover {
          background: var(--info_color);
        }

        .leftss {
          display: flex;
          align-items: center;
          width: 16%;

          .img {
            width: 25px;
            height: 25px;
            border-radius: 50%;
          }

          .img2 {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: var(--text_color);
            color: var(--background_color);
            font-size: 18px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          span {
            font-size: 14px;
            color: var(--text_color);
            font-weight: bold;
            margin-left: 10px;
          }
        }

        .right {
          width: 16%;
          display: flex;
          align-items: center;
          justify-content: left;

          .rr {
            .r1 {
              font-size: 14px;
              color: var(--text_color);
              font-weight: bold;
            }

            .r2 {
              margin-top: 10px;
              font-size: 12px;
              color: var(--ntext_color);
            }
          }
        }

        span {
          width: 16%;
          text-align: left;
          font-size: 14px;
          color: var(--text_color);
          font-weight: bold;
        }

        .itm3 {
          width: 16%;
          text-align: left;
          font-size: 14px;
          color: #3966ec;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    .coinInfo {
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .lef {
          font-size: 25px;
          font-weight: bold;
          color: var(--text_color);
          display: flex;
          align-items: center;

          span {
            margin-right: 10px;
          }
        }

        .btns {
          display: flex;
          align-items: center;
          justify-content: center;

          .t1 {
            padding: 15px 30px;
            font-size: 14px;
            color: var(--background_color);
            background: var(--text_color);
            border-radius: 25px;

            &:hover {
              opacity: 0.8;
            }
          }

          .t2 {
            margin-left: 20px;
            padding: 15px 30px;
            font-size: 14px;
            color: var(--text_color);
            background: var(--info_color);
            border-radius: 25px;

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }

      .topInfo {
        margin: 30px 0 50px 0;
        padding: 30px;
        border-radius: 15px;
        background: var(--info_color);

        .tit {
          display: flex;
          align-items: center;

          span {
            margin-left: 5px;
            font-size: 14px;
            color: var(--ntext_color);
          }
        }

        .num {
          margin-top: 20px;
          font-size: 30px;
          font-weight: 800;
          color: var(--text_color);

          span {
            margin-left: 5px;
            font-size: 16px;
            font-weight: normal;
            color: var(--ntext_color);
          }
        }

        .billss {
          margin-top: 20px;
          font-size: 14px;
          color: #3966ec;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .lable {
        margin-left: 10px;
        font-size: 15px;
        color: var(--text_color);
        display: flex;
        align-items: center;

        span {
          margin-left: 5px;
        }
      }

      .tits {
        margin-top: 30px;
        display: flex;
        align-items: center;
        padding: 15px;
        background: var(--info_color);
        font-size: 12px;
        color: var(--ntext_color);
        opacity: 0.8;

        span {
          width: 20%;
        }
      }

      .item {
        padding: 15px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid var(--info_color);

        &:hover {
          background: var(--info_color);
        }

        .leftss {
          width: 20%;
          display: flex;
          align-items: center;

          .img {
            width: 25px;
            height: 25px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }

        .right {
          width: 20%;
          display: flex;
          align-items: center;
          justify-content: left;

          .rr {
            .r1 {
              font-size: 14px;
              color: var(--text_color);
              font-weight: bold;
            }

            .r2 {
              margin-top: 10px;
              font-size: 12px;
              color: var(--ntext_color);
            }
          }
        }

        span {
          width: 20%;
          text-align: left;
          font-size: 14px;
          color: var(--text_color);
          font-weight: bold;
        }
      }
    }

    .walletInfo {
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .lef {
          font-size: 25px;
          font-weight: bold;
          color: var(--text_color);
          display: flex;
          align-items: center;

          span {
            margin-right: 10px;
          }
        }

        .btns {
          display: flex;
          align-items: center;
          justify-content: center;

          .t1 {
            padding: 15px 30px;
            font-size: 14px;
            color: var(--background_color);
            background: var(--text_color);
            border-radius: 25px;

            &:hover {
              opacity: 0.8;
            }
          }

          .t2 {
            margin-left: 20px;
            padding: 15px 30px;
            font-size: 14px;
            color: var(--text_color);
            background: var(--info_color);
            border-radius: 25px;

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }

      .topInfo {
        margin: 30px 0 50px 0;
        padding: 30px;
        border-radius: 15px;
        background: var(--info_color);

        .tit {
          display: flex;
          align-items: center;

          span {
            margin-left: 5px;
            font-size: 14px;
            color: var(--ntext_color);
          }
        }

        .num {
          margin-top: 20px;
          font-size: 30px;
          font-weight: 800;
          color: var(--text_color);

          span {
            margin-left: 5px;
            font-size: 16px;
            font-weight: normal;
            color: var(--ntext_color);
          }
        }
      }

      .billss {
        margin-top: 20px;
        font-size: 14px;
        color: #3966ec;

        &:hover {
          opacity: 0.8;
        }
      }

      .lable {
        margin-left: 10px;
        font-size: 15px;
        color: var(--text_color);
        display: flex;
        align-items: center;

        span {
          margin-left: 5px;
        }
      }

      .tits {
        margin-top: 30px;
        display: flex;
        align-items: center;
        padding: 15px;
        background: var(--info_color);
        font-size: 12px;
        color: var(--ntext_color);
        opacity: 0.8;

        span {
          width: 20%;
        }
      }

      .item {
        padding: 15px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid var(--info_color);

        &:hover {
          background: var(--info_color);
        }

        .leftss {
          width: 20%;
          display: flex;
          align-items: center;

          .img {
            width: 25px;
            height: 25px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }

        .right {
          width: 20%;
          display: flex;
          align-items: center;
          justify-content: left;

          .rr {
            .r1 {
              font-size: 14px;
              color: var(--text_color);
              font-weight: bold;
            }

            .r2 {
              margin-top: 10px;
              font-size: 12px;
              color: var(--ntext_color);
            }
          }
        }

        span {
          width: 20%;
          text-align: left;
          font-size: 14px;
          color: var(--text_color);
          font-weight: bold;
        }
      }
    }

    .financeInfo {
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .lef {
          font-size: 25px;
          font-weight: bold;
          color: var(--text_color);
          display: flex;
          align-items: center;

          span {
            margin-right: 10px;
          }
        }

        .btns {
          display: flex;
          align-items: center;
          justify-content: center;

          .t1 {
            padding: 15px 30px;
            font-size: 14px;
            color: var(--background_color);
            background: var(--text_color);
            border-radius: 25px;

            &:hover {
              opacity: 0.8;
            }
          }

          .t2 {
            margin-left: 20px;
            padding: 15px 30px;
            font-size: 14px;
            color: var(--text_color);
            background: var(--info_color);
            border-radius: 25px;

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }

      .topInfo {
        margin-top: 30px;
        padding: 30px;
        border-radius: 15px;
        background: var(--info_color);

        .numInfo {
          display: flex;

          .items {
            margin-right: 200px;

            .tit {
              display: flex;
              align-items: center;

              span {
                margin-left: 5px;
                font-size: 14px;
                color: var(--ntext_color);
              }
            }

            .num {
              margin-top: 20px;
              font-size: 30px;
              font-weight: 800;
              color: var(--text_color);

              span {
                margin-left: 5px;
                font-size: 16px;
                font-weight: normal;
                color: var(--ntext_color);
              }
            }
          }
        }

        .billss {
          margin-top: 20px;
          font-size: 14px;
          color: #3966ec;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .tits {
        margin-top: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px;
        background: var(--info_color);
        font-size: 12px;
        color: var(--ntext_color);
        opacity: 0.8;

        span {
          width: 16%;
        }
      }

      .item {
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid var(--info_color);

        &:hover {
          background: var(--info_color);
        }

        .leftss {
          display: flex;
          align-items: center;
          width: 16%;

          .img {
            width: 25px;
            height: 25px;
            border-radius: 50%;
          }

          .img2 {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: var(--text_color);
            color: var(--background_color);
            font-size: 18px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          span {
            font-size: 14px;
            color: var(--text_color);
            font-weight: bold;
            margin-left: 10px;
          }
        }

        .right {
          width: 16%;
          display: flex;
          align-items: center;
          justify-content: left;

          .rr {
            .r1 {
              font-size: 14px;
              color: var(--text_color);
              font-weight: bold;
            }

            .r2 {
              margin-top: 10px;
              font-size: 12px;
              color: var(--ntext_color);
            }
          }
        }

        span {
          width: 16%;
          text-align: left;
          font-size: 14px;
          color: var(--text_color);
          font-weight: bold;
        }

        .itm3 {
          width: 16%;
          text-align: left;
          font-size: 14px;
          color: #3966ec;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    .rechargeSelInfo {
      padding: 20px;

      .tit {
        margin-bottom: 30px;
        text-align: center;
        font-size: 21px;
        font-weight: bold;
        color: var(--text_color);
      }

      .tabs {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-weight: bold;
        color: var(--text_color);
        background: var(--background_color);
        border-radius: 10px;
        padding: 20px;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}

::v-deep .van-popup--center {
  border-radius: 15px;
  background: var(--info_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}

::v-deep .van-checkbox__icon--checked .van-icon {
  color: var(--background_color);
}
</style>
